<template>
  <b-modal
    id="verify-phone-modal"
    ref="verifyPhoneModal"
    modal-class="info-modal"
    title="Verify Phone Number"
    size="md"
    @hidden="clear">
    <span class="description">
      We just sent you a WhatsApp message with a code to <b>{{ phoneNumber }}</b>
    </span>
    <!-- <span class="description">
      Please note that SMS delivery can take <b>30 seconds</b> or more.
    </span> -->
    <span class="description">
      Code is valid for <b>15 minutes</b>.
    </span>
    <label
      class="col-form-label pt-0">
      Enter 4 digit code
    </label>
    <b-form-group>
      <b-input
        v-model="smscode"
        v-validate="'required|sbSMSCode'"
        name="smscode"
        data-vv-as="SMS code"
        placeholder="1 2 3 4"
        autofocus
        class="sm-4"
        @keyup.enter="checkCode"/>
      <span
        v-if="errors.has('smscode')"
        class="validation-error">{{ errors.first('smscode') }}</span>
      <span
        v-if="validationErrors.smscode"
        class="validation-error">{{ validationErrors.smscode }}</span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <span class="description">
      Didn't receive a code?
      <span
        class="click-here"
        @click="resend">&nbsp;Click to resend.</span>
    </span>
    <template slot="modal-footer">
      <b-button
        :class="{loading: verifying}"
        :disabled="verifying"
        @click="checkCode">
        <span v-if="!verifying">Confirm</span>
        <div
          v-if="verifying"
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
.description {
  display: block;
  color: $stateGray;
  font-size: 12px;
  font-weight: 500;
    margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .click-here {
    font-weight: 700;

    &:hover {
      color: $bluePrimary;
      cursor: pointer;
    }
  }
}

.error-message {
  margin-bottom: 16px;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'VerifyPhoneModal',
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      smscode: '',
      verifying: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'user/apiError',
      phoneVerifyFinished: 'user/phoneVerifyFinished',
    }),
  },
  watch: {
    apiError(error) {
      this.verifying = false;
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data ? error.data.message : '';
      }
    },
    phoneVerifyFinished(status) {
      if (status) {
        this.$emit('verified', true);
        this.hide();
      }
      this.verifying = false;
    },
  },
  methods: {
    ...mapActions({
      requestPhoneVerification: 'user/requestPhoneVerification',
      verifyPhone: 'user/verifyPhone',
      clearApiError: 'user/clearApiError',
    }),
    checkCode() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.verifying = true;
          this.verifyPhone({
            code: this.smscode,
          });
        }
      });
    },
    resend() {
      this.requestPhoneVerification({ channel: 'whatsapp' });
    },
    show() {
      this.$refs.verifyPhoneModal.show();
      this.requestPhoneVerification({ channel: 'whatsapp' });
    },
    clear() {
      //   Object.assign(this.$data, this.$options.data.apply(this));
      this.clearApiError();
      this.verifying = false;
      this.smscode = '';
    },
    hide() {
      this.$refs.verifyPhoneModal.hide();
    },
  },
};
</script>
